import React from "react";
import Countdown from "@/components/Countdown";
import Reveal from "@/components/Reveal";
import Ornament from "@/components/Ornament";
import PosterImage from "@/components/PosterImage";
import { EVENT, TICKET_URL, POSTER_UTAMA } from "@/data/content";
import { scrollToId } from "@/lib/scroll";
import { trackTicketClick } from "@/lib/analytics";

export default function Hero() {
  return (
    <section className="hero" id="hero" data-testid="section-hero">
      <div
        className="hero__bg"
        style={{ backgroundImage: `url(${POSTER_UTAMA.tinyWebp})` }}
        aria-hidden="true"
      />
      <div className="hero__veil" aria-hidden="true" />
      <div className="pattern pattern--hero" aria-hidden="true" />
      <div className="hero__glow" aria-hidden="true" />

      <div className="hero__grid">
        <div className="hero__content">
          <Reveal variant="fade">
            <div className="eyebrow" data-testid="hero-eyebrow">
              <span className="eyebrow__line" />
              {EVENT.brand}
              <span className="eyebrow__line" />
            </div>
          </Reveal>

          <Reveal variant="up" delay={80}>
            <h1 className="hero__title" data-testid="hero-title">
              Syukur <em>26</em>
            </h1>
          </Reveal>

          <Reveal variant="fade" delay={140}>
            <Ornament variant="divider" className="hero__orn" />
          </Reveal>

          <Reveal variant="up" delay={180}>
            <p className="hero__tagline" data-testid="hero-tagline">
              {EVENT.taglineUpper}
            </p>
          </Reveal>

          <Reveal variant="up" delay={240}>
            <p className="hero__meta" data-testid="hero-meta">
              {EVENT.dateUpper} &nbsp;&middot;&nbsp; {EVENT.timeRange}
              <br />
              {EVENT.venueUpper}
            </p>
          </Reveal>

          <Reveal variant="scale" delay={320}>
            <div className="hero__cd">
              <Countdown testId="hero-countdown" size="lg" />
            </div>
          </Reveal>

          <Reveal variant="up" delay={420}>
            <div className="hero__actions">
              <a
                className="btn btn--gold btn--lg"
                href={TICKET_URL}
                target="_blank"
                rel="noreferrer"
                onClick={() => trackTicketClick("hero")}
                data-testid="hero-cta-beli-tiket"
              >
                BELI TIKET
              </a>
              <button
                className="btn btn--ghost btn--lg"
                onClick={() => scrollToId("tiket")}
                data-testid="hero-cta-harga"
              >
                LIHAT HARGA TIKET
              </button>
            </div>
          </Reveal>
        </div>

        <Reveal variant="scale" delay={260} className="hero__posterwrap">
          <button
            className="hero__poster"
            onClick={() => scrollToId("poster")}
            aria-label="Lihat poster rasmi"
            data-testid="hero-poster"
          >
            <PosterImage
              poster={POSTER_UTAMA}
              size="thumb"
              eager
              testId="hero-poster-image"
            />
          </button>
        </Reveal>
      </div>

      <button
        className="hero__scroll"
        onClick={() => scrollToId("butiran")}
        data-testid="hero-scroll-indicator"
      >
        <span className="hero__scroll-text">SCROLL</span>
        <span className="hero__scroll-line" />
      </button>
    </section>
  );
}
